export default "__VITE_ASSET__CV0I78jt__"